export default __webpack_public_path__ + "static/jungle-game-template-dfb728e897ac1a29c64a1bb253ded6bb.jpg";